<template>
  <div style="padding-bottom: 60px" v-if="body_show">
    <!-- 公用头部 -->
    <public-header :colors="'#fff'" :headimg="headImg"></public-header>
    <div class="men_detail">
      <img v-for="(item,index) in picture" :key="index" :src="item" />
    </div>
    <div class="men_foots">
      <a @click="complete_click" v-if="data.complete">查看报告</a>
      <router-link :to="{path:'/measurement',query:{'cid':cids}}" v-else>立即开始测评</router-link>
    </div>
    <!-- 悬浮按钮 -->
    <div class="tjhy" @click="card_show=true">
      <div>推荐好友</div>
    </div>
    <div class="pop_img" v-show="card_show" @click="card_show=false"></div>
    <public-card :imgLink="imgLink" ref="card"></public-card>
  </div>
</template>
<script>
import {
  measurement_details
} from "@/api/measurement";
import {
  queryString
} from "@/utils/tools";
import {
  shareCon
} from "@/utils/wxconfig";
let img = require('../../../assets/cep_ewm.png');
export default {
  data() {
      return {
        headImg: "",
        picture: "",
        data: {},
        body_show: false,
        subscribe: false,
        cids: "",
        card_show: false,
        imgLink: img,
        link: "",
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: ""
        }
      }
    },
    methods: {
      pullData() {
        let cid = this.$route.query.cid;
        measurement_details({
            cid: cid
          })
          .then((data) => {
            this.body_show = true;
            document.title = data.headtitle;
            this.data = data;
            this.headImg = data.userinfo.headimgurl;
            this.picture = data.picture;
            this.subscribe = data.subscribe;
            this.subscribe = data.need_subscribe;
            this.cids = queryString(data.link, 'cid');
            // 给wxconfig传对象
            this.type_obj.evaluation_id = this.$route.query.cid;
            this.type_obj.evaluation_name = data.headtitle;
            this.type_obj.evaluation_user_id = String(data.uid);
            this.type_obj.path = this.$route.path;
            // link
            this.link = data.link;
            shareCon("measurement", this, this.type_obj);

            // 神策统计--打开页面时触发
            sensors.track('evaluationPage', {
              evaluation_id: this.$route.query.cid,
              evaluation_name: this.data.headtitle,
              evaluation_url: window.location.href,
              evaluation_page_title: this.data.headtitle,
              share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
              channel_name: this.$route.query.channel ? this.$route.query.channel : ""
            })
          })
      },
      complete_click() {
        let query = this.url_substying(this.link);
        if (this.subscribe || !this.need_subscribe) {
          this.$router.push("/measurement_report" + query)
        } else {
          this.$refs.card.card_show = true;
        }
      },
      // 截取返回link中的地址中的路由名称
      url_substying(url_) {
        let index = url_.lastIndexOf('?');
        // let last = url_.lastIndexOf('.');
        let x = url_.substring(index);
        return x;
      },
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.men_detail {
  width: 100%;
  text-align: center;
  img {
    width: 100%;
  }
}

.men_foots {
  width: 100%;
  height: changeRem(1.96) + px;
  line-height: changeRem(1.96) + px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  max-width: 750px;
  text-align: center;
  background: #EB5032;
  z-index: 2;
  color: #fff;
  font-size: changeRem(0.68) + px;
  a {
    display: block;
    width: 100%;
    height: 100%;
    color: #fff
  }
}

.tjhy {
  position: fixed;
  z-index: 998;
  width: 150px;
  top: changeRem(2.72)+px;
  text-align: center;
  right: 50%;
  margin-right: -375px;
  height: changeRem(1.4)+px;
  background-color: #EB5032;
  border-radius: changeRem(.56)+px 0 0 changeRem(.56)+px;
  padding-left: changeRem(.12)+px;
  padding-top: changeRem(.1)+px;
  div {
    width: changeRem(2.84)+px;
    line-height: changeRem(1.12)+px;
    border: 2px solid #ffffff;
    border-right: 0;
    color: #FFFFFF;
    font-size: changeRem(.48)+px;
    border-radius: changeRem(.56)+px 0rem 0rem changeRem(.56)+px;
  }
}

.tjhy.kfan {
  top: changeRem(4.72)+px;
  background-color: #F57F17;
  div {
    width: changeRem(2.84)+px;
    line-height: changeRem(1.12)+px;
    border: 2px solid #ffffff;
    border-right: 0;
    color: #FFFFFF;
    font-size: changeRem(.48)+px;
    border-radius: changeRem(.56)+px 0rem 0rem changeRem(.56)+px;
  }
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}
</style>
